import styled from 'styled-components';
import { ChevronDown } from 'ui/icons';
import { SecondaryButton } from 'ui/button';
import { body2, button, colors, spacing, zIndex } from 'ui/theme';

export const DatePickerContainer = styled.div<{ isDisabled: boolean }>`
  display: inline-block;
  padding-left: ${spacing.half};

  > span {
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'default')};
  }
`;

export const DatePickerTriggerButton = styled(SecondaryButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};
  padding: ${spacing.threeQuarter} ${spacing.threeQuarter};

  :focus {
    &::before {
      border-color: transparent !important;
    }
  }

  :hover {
    background: ${colors.white} !important;
  }
`;

export const DatePickerWrapper = styled.div`
  position: absolute;
  z-index: ${zIndex.dropdown};
  background-color: ${colors.white};
  color: ${colors.textPrimary};
  border-radius: ${spacing.half};

  [data-test='EXPERIMENT_START_TO_NOW-preset'],
  [data-test='EXPERIMENT_START_TO_NOW-preset-selected'],
  [data-test='EXPERIMENT_PERIOD-preset'],
  [data-test='EXPERIMENT_PERIOD-preset-selected'] {
    margin-top: 0;
  }
`;

export const ButtonText = styled.span<{ isDisabled: boolean }>`
  ${button};
  margin: 0;
  color: ${({ isDisabled }) => (isDisabled ? colors.textDisabled : colors.textPrimary)};
`;

export const StyledChevronDown = styled(ChevronDown)`
  margin: 0;
`;

export const TimeInfo = styled.span`
  ${body2};
  color: ${colors.purple20};
`;
